
import { toast } from "@/hooks/use-toast";

export const useFileHandler = () => {
  const handleMediaChange = (
    files: FileList,
    currentFiles: File[],
    onFilesChange: (files: File[]) => void
  ) => {
    console.log(
      "Media files selected:",
      Array.from(files).map((f) => f.name)
    );
    const fileArray = Array.from(files);

    const combinedFiles = [...currentFiles, ...fileArray];
    const limitedFiles = combinedFiles.slice(0, 10);

    onFilesChange(limitedFiles);

    if (combinedFiles.length > 10) {
      toast({
        title: "Too many files",
        description: `Only the first 10 files were selected. Maximum of 10 files allowed.`,
        variant: "default",
      });
    }
  };

  return { handleMediaChange };
};
